<ul class="p-sub-column-layout04__list" [ngStyle]="isPC ? {} : { 'background-color': '#fff' }">
  <!-- 予約詳細へボタン -->
  <li class="p-sub-column-layout04__list-item">
    <a
      class="u-focus-cursor-pointer"
      [ngClass]="{ 'p-sub-column-layout04__list-link': true, 'p-sub-column-layout04__list-link-sp': !isPC }"
      role="button"
      tabindex="0"
      id="booking-completed-pres-go-to-mybooking-2"
      (throttleClick$)="clickGoToMyBookingEvent()"
      [innerHTML]="'message.fowardReservationDetails' | staticMsg"
      aswThrottleClick
    ></a>
  </li>

  <!-- ASW TOPへボタン -->
  <li class="p-sub-column-layout04__list-item">
    <a
      class="u-focus-cursor-pointer"
      [ngClass]="{ 'p-sub-column-layout04__list-link': true, 'p-sub-column-layout04__list-link-sp': !isPC }"
      role="button"
      tabindex="0"
      id="booking-completed-pres-go-to-asw-top-2"
      (throttleClick$)="clickGoToAswTopEvent()"
      [innerHTML]="'label.backToTop' | staticMsg"
      aswThrottleClick
    ></a>
  </li>
</ul>
